<template>
    <base-dialog :value="dialog" :width="360"
        :title="editing ? $t('exercises.edit_rest') : $t('exercises.add_rest')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="rest-body">
            <kimsa-time-picker ref="picker" :value="time" @change="onChange" />
        </div>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.save')" :disabled="disabled" @confirm="setRest" />
        </template>
    </base-dialog>
</template>

<script>


import KimsaTimePicker from "@/components/common/KimsaTimePicker";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

export default {
    name: 'RestDialog',
    props: {
        asMenu: {
            type: Boolean,
            default: false,
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        }
    },
    components: {
        KimsaTimePicker,
        BaseDialog,
        DialogActions,
    },
    data() {
        return {
            editing: false,
            time: '00:00:00',
            dialog: false,
        }
    },
    computed: {
        disabled(vm = this) {
            return !vm.time || vm.time === '00:00:00'
        }
    },
    mounted() {
        const vm = this
        vm.setDefault()
    },
    methods: {
        onChange(time) {
            const vm = this
            vm.time = time
        },
        show(edit) {
            const vm = this
            if (!edit) vm.time = '00:00:00'
            vm.dialog = true
            if (vm.$refs.picker) vm.$refs.picker.setDefault()
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.editing = false
        },
        showEdit(time) {
            const vm = this
            vm.editing = true
            vm.time = time
            vm.show(true)
        },
        setRest() {
            const vm = this
            vm.$emit('save', vm.time)
            vm.hide()
        },
        setDefault() {
            const vm = this
            if (!vm.value) return
            vm.time = vm.value
        }
    },
    watch: {
        value() {
            this.setDefault()
        },


    }
}

</script>

<style scoped>
.rest-body {
    text-align: center;
}

.rest-sub {
    font-size: 12px;
    color: var(--v-accent-base);
    margin-bottom: 8px;
}
</style>